$(function(){
	var tabs = $('ul.tabs'),
		tab = tabs.find('.tab');
	tabs.each(function(){
		var $tabs = $(this).flickity({
			prevNextButtons:false,
			pageDots:false,
			freeScroll:true,
			contain:true,
			cellAlign:'left',
			draggable:true
		});
		$tabs.flickity('select',tab.filter('.active').index())
	});
	tab.click(function(event){
		event.preventDefault();
		$(this).addClass('active').siblings('.tab').removeClass('active');
	});

	//distributor tab sections
	$('section.distributor').each(function() {

		var $this = $(this);

		$this.find('.distributor-header__nav li button').on('click', function() {
			var distTarget = $this.find('.distributor-list').find('[data-distributor=' + $(this).data('distributor') + ']');
			
			$('html, body').stop().animate({
				scrollTop: $(distTarget).offset().top - $this.find('.distributor-header').height()
			}, 500);

		})
	});
});